import React, {Component} from "react";
import {Container, Row, Col, Card, CardBody, Alert, UncontrolledDropdown, DropdownToggle, DropdownMenu, Progress} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import cellEditFactory from 'react-bootstrap-table2-editor';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {withTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {
  filesFilter,
  filesSegments,
  filesList,
  filesProcessRefresh,
  filesSlipQRUpdate,
  filesDownload,
  filesSlipMKSoftDownload,
  filesInvoiceIssuedMKSoftDownload,
  filesInvoiceDeliveredMKSoftDownload
} from "../../store/files/actions";
import {connect} from "react-redux";
import Select from "react-select";
import {formatBytes, getUser} from "../../common/general";
import {API_URL} from "../../common/config";
import {format} from 'react-string-format';
import SlipDetailModal from "./SlipDetailModal";
import ProgressRefresh from "./ProgressRefresh";
import InvoiceDetailModal from "./InvoiceDetailModal";
import ConfirmModal from "../../components/Common/ConfirmModal";
import {apiDeleteFilesDelete} from "../../api/calls/files";
import SmallAvatar from "../../components/Common/SmallAvatar";

class Files extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sections: [],
      years: [],
      months: [],
      selectedSection: null,
      selectedYear: null,
      selectedMonth: null,
      loadingFilter: false,
      errorFilter: "",
      segments: [],
      selectedSegment: parseInt(localStorage.getItem("filesSegment")),
      loadingSegment: false,
      errorSegment: "",
      files: [],
      loadingList: false,
      errorList: "",
      deleteModal: false,
      slipDetailModal: false,
      invoiceDetailModal: false,
      sizePerPage: parseInt(localStorage.getItem('tablePageSize')) || 10,
      dataSize: 0,
      actualFile: "",
    }
    this.onSelectSection = this.onSelectSection.bind(this)
    this.onSelectYear = this.onSelectYear.bind(this)
    this.onSelectMonth = this.onSelectMonth.bind(this)
    this.onSelectSegment = this.onSelectSegment.bind(this)
    this.refreshFiles = this.refreshFiles.bind(this)
    this.togDelete = this.togDelete.bind(this)
    this.togSlipDetail = this.togSlipDetail.bind(this)
    this.togInvoiceDetail = this.togInvoiceDetail.bind(this)
    this.onSizePerPageChange = this.onSizePerPageChange.bind(this)
    this.onDataSizeChange = this.onDataSizeChange.bind(this)
  }

  componentDidMount() {
    this.props.onFilesFilter({history: this.props.history});
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        sections: this.props.responseFilter ? this.props.responseFilter.response.sections : [],
        years: this.props.responseFilter ? this.props.responseFilter.response.years : [],
        months: this.props.responseFilter ? this.props.responseFilter.response.months : [],
        loadingFilter: this.props.loadingFilter,
        errorFilter: this.props.errorFilter,
        segments: this.props.responseSegments ? this.props.responseSegments.response.segments : [],
        loadingSegments: this.props.loadingSegments,
        errorSegments: this.props.errorSegments,
        files: this.props.responseList ? this.props.responseList.response : [],
        loadingList: this.props.loadingList,
        errorList: this.props.errorList,
      });
    }
    if (prevProps.responseFilter === null && this.props.responseFilter && this.props.responseFilter.response.sections.length > 0) {
      const filesSection = JSON.parse(localStorage.getItem("filesSection"))
      if (filesSection && this.props.responseFilter.response.sections.some(s => s.value === filesSection.value)) {
        this.onSelectSection(filesSection)
      } else {
        this.onSelectSection(this.props.responseFilter.response.sections[0])
      }
      const filesYear = JSON.parse(localStorage.getItem("filesYear"))
      if (filesYear && this.props.responseFilter.response.years.some(y => y.value === filesYear.value)) {
        this.onSelectYear(filesYear)
      } else {
        const actualYear = (new Date().getFullYear()).toString()
        const year = this.props.responseFilter.response.years.find(y => y.label === actualYear)
        this.onSelectYear(year)
      }
      const filesMonth = JSON.parse(localStorage.getItem("filesMonth"))
      if (filesMonth && this.props.responseFilter.response.months.some(m => m.value === filesMonth.value)) {
        this.onSelectMonth(filesMonth)
      } else {
        const actualMonth = (new Date().getMonth() + 1).toString()
        const month = this.props.responseFilter.response.months.find(m => m.value === actualMonth)
        this.onSelectMonth(month)
      }
    }
  }

  onSelectSection(selectedSection) {
    this.setState((prevState) => {
      localStorage.setItem("filesSection", JSON.stringify(selectedSection))
      this.loadSegments(selectedSection.value, prevState.selectedYear ? prevState.selectedYear.value : null, prevState.selectedMonth ? prevState.selectedMonth.value : null)
      return ({
        selectedSection: selectedSection,
      })
    });
  }

  onSelectYear(selectedYear) {
    this.setState((prevState) => {
      localStorage.setItem("filesYear", JSON.stringify(selectedYear))
      this.loadSegments(prevState.selectedSection ? prevState.selectedSection.value : null, selectedYear.value, prevState.selectedMonth ? prevState.selectedMonth.value : null)
      return ({
        selectedYear: selectedYear,
      })
    });
  }

  onSelectMonth(selectedMonth) {
    this.setState((prevState) => {
      localStorage.setItem("filesMonth", JSON.stringify(selectedMonth))
      this.loadSegments(prevState.selectedSection ? prevState.selectedSection.value : null, prevState.selectedYear ? prevState.selectedYear.value : null, selectedMonth.value)
      return ({
        selectedMonth: selectedMonth,
      })
    });
  }

  loadSegments(sectionId, yearId, monthId) {
    if (sectionId && yearId && monthId) {
      this.props.onFilesSegments({data: {sectionId: sectionId, yearId: yearId, monthId: monthId}, history: this.props.history})
      if (this.state.selectedSegment) {
        this.loadFiles(sectionId, yearId, monthId, this.state.selectedSegment.toString())
      }
    }
  }

  onSelectSegment(segmentId) {
    localStorage.setItem("filesSegment", segmentId)
    this.setState((prevState) => {
      this.loadFiles(prevState.selectedSection.value, prevState.selectedYear.value, prevState.selectedMonth.value, segmentId.toString())
      return ({
        selectedSegment: segmentId,
      })
    });
  }

  loadFiles(sectionId, yearId, monthId, segmentId) {
    if (sectionId && yearId && monthId && segmentId) {
      this.props.onFilesList({data: {sectionId: sectionId, yearId: yearId, monthId: monthId, segmentId: segmentId}, history: this.props.history})
    }
  }

  refreshFiles() {
    if (this.state.selectedSection && this.state.selectedYear && this.state.selectedMonth && this.state.selectedSegment) {
      this.loadFiles(this.state.selectedSection.value, this.state.selectedYear.value, this.state.selectedMonth.value, this.state.selectedSegment.toString())
    }
  }

  togDelete(data = null) {
    this.setState(prevState => ({
      actualFile: data ? data.name : "",
      actionData: data ? data.data : null,
      deleteModal: !prevState.deleteModal,
    }))
  }

  togSlipDetail(data = null) {
    this.setState(prevState => ({
      slipData: data,
      slipDetailModal: !prevState.slipDetailModal,
    }))
  }

  togInvoiceDetail(data = null) {
    this.setState(prevState => ({
      invoiceData: data,
      invoiceDetailModal: !prevState.invoiceDetailModal,
    }))
  }

  onSizePerPageChange(sizePerPage) {
    localStorage.setItem('tablePageSize', String(sizePerPage));
    this.setState(prevState => ({
      sizePerPage: sizePerPage,
    }))
  }

  onDataSizeChange({dataSize}) {
    this.setState(prevState => ({
      dataSize: dataSize,
    }))
  }

  render() {
    document.title = "Files | FileJet";

    const uploaderFormatter = (cell, row) => {
      return (<div>
        <SmallAvatar user={row.uploader} history={this.props.history}/>
      </div>);
    }

    const actionFormatter = (cell, row) => {
      return (<div>
        <a className="bx bx-download font-size-20" title="Download" onClick={() => (this.props.onFilesDownload({sign: row.sign, filename: row.name, history: this.props.history}))}></a>
        {this.state.selectedSegment >= 1 && this.state.selectedSegment <= 3 && <a className="bx bx-reset font-size-20" title="Reprocess" onClick={() => {
          this.props.onFilesProcessRefresh({data: {sign: row.sign}, refreshFiles: this.refreshFiles, history: this.props.history})
        }}></a>}
        <a className="bx bx-x font-size-20" title="Delete" onClick={() => this.togDelete({data: {sign: row.sign}, name: row.name})}></a>
      </div>);
    }

    const dataFormatter = (cell, row) => {
      return (<div>
        {row.data === 0 && <i className="bx bx-log-in-circle font-size-20 text-primary"></i>}
        {row.data === 1 && <i className="bx bx-check-circle font-size-20 text-success"></i>}
        {row.data === 2 && <i className="bx bx-x-circle font-size-20 text-danger"></i>}
        {(this.state.selectedSegment === 1 || this.state.selectedSegment === 2) && (row.data === 1 || row.data === 2) &&
          <a className="bx bx-detail font-size-20" title="Detail" onClick={() => this.togInvoiceDetail({sign: row.sign, name: row.name, sectionId: this.state.selectedSection.value})}></a>}
        {(this.state.selectedSegment === 3) && (row.data === 1 || row.data === 2) &&
          <a className="bx bx-detail font-size-20" title="Detail" onClick={() => this.togSlipDetail({sign: row.sign, name: row.name, sectionId: this.state.selectedSection.value})}></a>}
      </div>);
    }

    const lastEditorFormatter = (cell, row) => {
      return (<div>
        {row.last_editor > 0 && <SmallAvatar user={row.last_editor} history={this.props.history}/>}
      </div>);
    }

    const clearFormatter = (cell, row) => {
      return (<div>
        {row.is_clear && <i className="bx bx-check-circle font-size-20 text-success"></i>}
        {!row.is_clear && <i className="bx bx-x-circle font-size-20 text-danger"></i>}
      </div>);
    }

    const afterSaveCellHandler = (oldValue, newValue, row, column) => {
      if (column.dataField === "qr") {
        if (newValue.length > 3) {
          this.props.onFilesSlipQRUpdate({sign: row.sign, data: {slip_value: newValue}, refreshFiles: this.refreshFiles, history: this.props.history})
        } else {
          row.qr = oldValue
        }
      }
    }

    const columns = [{
      dataField: "id", text: "Id", sort: true, editable: false,
    }, {
      dataField: "sign", text: "Sign", editable: false,
    }, {
      dataField: "name", text: "Name", sort: true, editable: false,
    }, {
      dataField: "uploader", text: "Uploader", sort: true, editable: false, formatter: uploaderFormatter,
    }, {
      dataField: "created", text: "Created", sort: true, editable: false,
    }, {
      dataField: "actions", text: "Actions", editable: false, formatter: actionFormatter,
    },];

    if (this.state.selectedSegment === 1 || this.state.selectedSegment === 2) {
      columns.splice(3, 0, {
        dataField: "data", text: "Data", sort: true, editable: false, formatter: dataFormatter,
      }, {
        dataField: "is_clear", text: "Clear", sort: true, editable: false, formatter: clearFormatter,
      }, {
        dataField: "total", text: "Total", sort: true, editable: false,
      }, {
        dataField: "account", text: "Account", sort: true, editable: false,
      }, {
        dataField: "delivery_date", text: "Delivery Date", sort: true, editable: false,
      }, {
        dataField: "last_editor", text: "Last Editor", sort: true, editable: false, formatter: lastEditorFormatter,
      })
    }

    if (this.state.selectedSegment === 3) {
      columns.splice(3, 0, {
        dataField: "qr", text: "QR", sort: true,
      }, {
        dataField: "data", text: "Data", sort: true, editable: false, formatter: dataFormatter,
      }, {
        dataField: "is_clear", text: "Clear", sort: true, editable: false, formatter: clearFormatter,
      }, {
        dataField: "total", text: "Total", sort: true, editable: false,
      }, {
        dataField: "account", text: "Account", sort: true, editable: false,
      }, {
        dataField: "date", text: "Date", sort: true, editable: false,
      }, {
        dataField: "last_editor", text: "Last Editor", sort: true, editable: false, formatter: lastEditorFormatter,
      })
    }

    const defaultSorted = [{
      dataField: "id", order: "asc",
    },];

    const pageOptions = {
      sizePerPage: this.state.sizePerPage, totalSize: this.state.dataSize, custom: true, onSizePerPageChange: this.onSizePerPageChange, sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }]
    };

    const {SearchBar} = Search;

    function onColumnMatch({searchText, value, column, row}) {
      if (row.name.toLowerCase().includes(searchText) || row.created.toLowerCase().includes(searchText)) return true
      return false
    }

    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={this.props.t("FileJet")} breadcrumbItem={this.props.t("Files")}/>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={columns}
                    data={this.state.files}
                  >
                    {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                      keyField="id"
                      columns={columns}
                      data={this.state.files}
                      search={{
                        onColumnMatch,
                      }}
                    >
                      {toolkitProps => (<React.Fragment>
                        <Row className="mb-2">
                          <Col className="col-4">
                            Section
                            <Select options={this.state.sections} value={this.state.selectedSection} onChange={this.onSelectSection}/>
                          </Col>
                          <Col className="col-2">
                            Year
                            <Select options={this.state.years} value={this.state.selectedYear} onChange={this.onSelectYear}/>
                          </Col>
                          <Col className="col-2">
                            Month
                            <Select options={this.state.months} value={this.state.selectedMonth} onChange={this.onSelectMonth}/>
                          </Col>
                          <Col md="4">
                            <div className="search-box me-2 mb-2 d-inline-block float-end">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} placeholder="Filter" delay={0}/>
                                <i className="bx bx-search-alt search-icon"/>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="mt-3">
                          {this.state.segments.map(segment => {
                            const segmentClass = this.state.selectedSegment === segment.id ? "shadow-none border bg-opacity-25 bg-info" : "shadow-none border"
                            return (<Col key={segment.id} md={2}>
                              <Card className={segmentClass} role="button" onClick={() => {
                                this.onSelectSegment(segment.id)
                              }}>
                                <CardBody className="p-3">
                                  <div className="">
                                    <div className="float-end ms-2">
                                      {(segment.id === 1 || segment.id === 2 || segment.id === 3) && <UncontrolledDropdown className="mb-2" direction="left">
                                        <DropdownToggle color="white" className="font-size-16 text-muted dropdown-toggle" tag="a">
                                          <i className="mdi mdi-dots-horizontal"></i>
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-end">
                                          {segment.id === 1 && <a
                                            onClick={() => (this.props.onFilesInvoiceDeliveredMKSoftDownload({
                                              data: {
                                                sectionId: this.state.selectedSection ? this.state.selectedSection.value : null,
                                                segmentId: segment.id,
                                                year: this.state.selectedYear ? this.state.selectedYear.value : null,
                                                month: this.state.selectedMonth ? this.state.selectedMonth.value : null
                                              },
                                              history: this.props.history
                                            }))}>
                                            <div className="dropdown-item">MKSoft Export</div>
                                          </a>}
                                          {segment.id === 2 && <a
                                            onClick={() => (this.props.onFilesInvoiceIssuedMKSoftDownload({
                                              data: {
                                                sectionId: this.state.selectedSection ? this.state.selectedSection.value : null,
                                                segmentId: segment.id,
                                                year: this.state.selectedYear ? this.state.selectedYear.value : null,
                                                month: this.state.selectedMonth ? this.state.selectedMonth.value : null
                                              },
                                              history: this.props.history
                                            }))}>
                                            <div className="dropdown-item">MKSoft Export</div>
                                          </a>}
                                          {segment.id === 3 && <a
                                            onClick={() => (this.props.onFilesSlipMKSoftDownload({
                                              data: {
                                                sectionId: this.state.selectedSection ? this.state.selectedSection.value : null,
                                                segmentId: segment.id,
                                                year: this.state.selectedYear ? this.state.selectedYear.value : null,
                                                month: this.state.selectedMonth ? this.state.selectedMonth.value : null
                                              },
                                              history: this.props.history
                                            }))}>
                                            <div className="dropdown-item">MKSoft Export</div>
                                          </a>}
                                        </DropdownMenu>
                                      </UncontrolledDropdown>}
                                    </div>
                                    <div className="avatar-xs me-3 mb-3">
                                      <div className="avatar-title bg-transparent rounded">
                                        <i className="bx bxs-folder font-size-24 text-warning"></i>
                                      </div>
                                    </div>
                                    <div>
                                      <div className="overflow-hidden me-auto">
                                        <h5 className="font-size-14 text-truncate mb-1">{segment.name}</h5>
                                      </div>
                                      <div className="d-flex">
                                        <div className="col-6"><p className="text-muted mb-0">{segment.count} Files</p></div>
                                        <div className="col-6" style={{"fontSize": ".7rem"}}><p className="text-muted mb-0 float-end">{formatBytes(segment.size)}</p></div>
                                      </div>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>)
                          })}
                        </Row>

                        <Row>
                          <ProgressRefresh function={this.refreshFiles}/>
                        </Row>

                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                onDataSizeChange={this.onDataSizeChange}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                                cellEdit={cellEditFactory({
                                  mode: 'dbclick',
                                  afterSaveCell: afterSaveCellHandler,
                                })}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-md-center mt-30">
                          <Col className="inner-custom-pagination d-flex">
                            <div className="d-inline">
                              <SizePerPageDropdownStandalone {...paginationProps}/>
                            </div>
                            <div className="text-md-right ms-auto">
                              <PaginationListStandalone {...paginationProps}/>
                            </div>
                          </Col>
                        </Row>
                      </React.Fragment>)}
                    </ToolkitProvider>)}
                  </PaginationProvider>
                  {this.state.loadingList && (<div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>)}
                  {this.state.errorList.length > 0 && (<div className="mt-3">
                    <Alert color="danger" role="alert">
                      {this.state.errorList}
                    </Alert>
                  </div>)}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.deleteModal &&
            <ConfirmModal togModal={this.togDelete} refreshParent={this.refreshFiles} title={"Delete File"} question={format("Do you really want to delete file {0}?", this.state.actualFile)}
                          actionName={"Delete"} actionColor={"danger"} call={apiDeleteFilesDelete} actionData={this.state.actionData} history={this.props.history}/>}
          {this.state.slipDetailModal && <SlipDetailModal togModal={this.togSlipDetail} slipData={this.state.slipData} refreshParent={this.refreshFiles} history={this.props.history}/>}
          {this.state.invoiceDetailModal && <InvoiceDetailModal togModal={this.togInvoiceDetail} invoiceData={this.state.invoiceData} refreshParent={this.refreshFiles} history={this.props.history}/>}
        </Container>
      </div>
    </React.Fragment>);
  }
}

Files.propTypes = {
  response: PropTypes.any,
  onFilesFilter: PropTypes.func,
  onFilesSegments: PropTypes.func,
  onFilesList: PropTypes.func,
  onFilesProcessRefresh: PropTypes.func,
  onFilesSlipQRUpdate: PropTypes.func,
  onFilesDownload: PropTypes.func,
  onFilesSlipMKSoftDownload: PropTypes.func,
  onFilesInvoiceIssuedMKSoftDownload: PropTypes.func,
  onFilesInvoiceDeliveredMKSoftDownload: PropTypes.func,
};

const mapStateToProps = ({Files}) => ({
  responseFilter: Files.responseFilter,
  loadingFilter: Files.loadingFilter,
  errorFilter: Files.errorFilter,
  responseSegments: Files.responseSegments,
  loadingSegments: Files.loadingSegments,
  errorSegments: Files.errorSegments,
  responseList: Files.responseList,
  loadingList: Files.loadingList,
  errorList: Files.errorList,
});

const mapDispatchToProps = dispatch => ({
  onFilesFilter: data => dispatch(filesFilter(data)),
  onFilesSegments: data => dispatch(filesSegments(data)),
  onFilesList: data => dispatch(filesList(data)),
  onFilesProcessRefresh: data => dispatch(filesProcessRefresh(data)),
  onFilesSlipQRUpdate: data => dispatch(filesSlipQRUpdate(data)),
  onFilesDownload: data => dispatch(filesDownload(data)),
  onFilesSlipMKSoftDownload: data => dispatch(filesSlipMKSoftDownload(data)),
  onFilesInvoiceIssuedMKSoftDownload: data => dispatch(filesInvoiceIssuedMKSoftDownload(data)),
  onFilesInvoiceDeliveredMKSoftDownload: data => dispatch(filesInvoiceDeliveredMKSoftDownload(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Files));
